import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/tile.js';
// import s from 'components/bolt/hub/components/carousel/tile.sss';
import { joinClasses } from 'utils/utils';
import Buttons from 'components/bolt/hub/components/buttons/buttons';
import Video from 'components/bolt/hub/components/video/video';
import s from 'components/bolt/hub/components/carousel/tile.sss';
import * as webp from 'utils/bolt/webp';
import HTML from 'components/core/html/html';
import HubTextOverlay from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay';
// import { navigateInternally, splitQueryAndPath } from 'utils/bolt/index';
import Store from 'store/store';

export default class Tile extends BaseComp.default {
	
	constructor(props) {
		super(props);
		this.signalVideoPlaying = this.signalVideoPlaying.bind(this);
		this.onVideoProgress = this.onVideoProgress.bind(this);
		this.switchToFallbackImg = this.switchToFallbackImg.bind(this);
		this.onTileClick = this.onTileClick.bind(this);
		this.updateTileWidthToAssetHeight = this.updateTileWidthToAssetHeight.bind(this);
		this.state = {
			shouldUseFallbackImg: false
		};
	}

	componentDidMount() {
		if (this.$video?.paused) {
			this.$video?.play();
		}
		if (this.props.verticalLayout) {
			this.updateTileWidthToAssetHeight();
			window.addEventListener('resize', this.updateTileWidthToAssetHeight);
		}
	}

	componentWillUnmount() {
		if (this.props.verticalLayout) {
			window.removeEventListener('resize', this.updateTileWidthToAssetHeight);
		}
	}

	updateTileWidthToAssetHeight() {
		if (!this.asset) return;
	
		const assetHeight = this.asset.offsetHeight;
		const bgImageUrl = this.asset.style.backgroundImage?.slice(5, -2);
	
		if (!bgImageUrl) return;
	
		const img = new Image();
		img.onload = () => {
			const naturalWidth = img.naturalWidth;
			const naturalHeight = img.naturalHeight;
	
			if (naturalWidth && naturalHeight) {
				let tileWidth = assetHeight * (naturalWidth / naturalHeight);
				this.setState({ tileWidth });
			}
		};
		img.src = bgImageUrl;
	}

	switchToFallbackImg() {
		this.setState({
			shouldUseFallbackImg: true
		});
	}

	signalVideoPlaying() {
		this.setState({
			videoPlaying: true
		});
	}

	onVideoProgress() {
		if (!this.state.videoPlaying) {
			this.setState({
				videoPlaying: true
			});
		}
	}

	onTileClick(e, carouselTitle, title, dragging, data) {
		if (dragging) return;
		Store.emit('CHANGE_YOUTUBE_VIDEO', data.youtubeId);
		
		Store.emit('CUSTOM_EVENT', {
			category: this.props.parentId,
			action: 'video-click',
			label: title + '_' + data.youtubeId,
		});
	}

	toggleTextOverlay(open) {
		this.setState({
			textOverlayOpen: open
		});
		Store.emit('CAROUSEL_TEXT_OVERLAY_SHOW', open ? this.props.carouselId : null);
	}

	renderTextOverlay(textOverlay) {
		if (!textOverlay) return;
		const show = this.state.textOverlayOpen;

		return (
			<HubTextOverlay
				content={textOverlay}
				show={show}
				closeOverlay={() => this.toggleTextOverlay(false)}
			/>
		);
	}

	render({ data, id, carouselHeader, carouselTitle, useTileSlantyTag, fallbackFormat, dragging }) {
		if (!data) return;
		//console.log(data);
		//const { asset, mobileAsset, tag, title, fallbackAsset, teaser, buttons, altText, path, videoOverlay, textOverlay } = data;

		const { buttons, altText, path, videoOverlay, textOverlay } = data;
		let asset = data?.thumbSrc;
		let title = data?.name;
		let fallbackAsset = data?.thumbSrc;
		let mobileAsset = asset;
		let tag = '';
		let teaser = '';

		
		const { shouldUseFallbackImg } = this.state;
		const isVideoAsset = /\.(mp4|webm)$/.test(asset);
		const textOverlayContent = textOverlay?.content;
		const isMobile = Store.get().client?.dimensions?.width < 1024;
		const isVertical = this.props.verticalLayout;
		const imageBgStyle = {
			backgroundImage: isMobile && mobileAsset ? webp.css(mobileAsset, fallbackFormat) : webp.css(asset, fallbackFormat),
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
		};

		if (shouldUseFallbackImg) {
			imageBgStyle.backgroundImage = webp.css(fallbackAsset, fallbackFormat);
		}

		const shouldHideAsset = isVideoAsset && !this.state.videoPlaying && !fallbackAsset;
		
		return (
			<div class={joinClasses(s.tile, isVertical && s.isVertical)} id={id} onClick={(e) => this.onTileClick(e, carouselTitle, title, dragging, data)} ref={ref => this.tile = ref} style={isVertical && this.state.tileWidth ? { width: `${this.state.tileWidth}px` } : {}}>
				<div
					class={joinClasses(s.asset, shouldHideAsset && s.hide, (path || videoOverlay?.video || textOverlay?.content) && s.clickable)}
					style={(!isVideoAsset || shouldUseFallbackImg) && imageBgStyle}
					ref={ref => this.asset = ref}
				>
					{(!isVideoAsset || shouldUseFallbackImg) && <span role="img" ariaLabel={altText} />}
					{isVideoAsset && (
						<Video
							ref={e => this.$video = e?.base}
							src={asset}
							onError={this.switchToFallbackImg}
							preloadImg={fallbackAsset}
							fallbackFormat={fallbackFormat}
							onPlay={this.signalVideoPlaying}
							onProgress={this.onVideoProgress}
							isTileVideo
							ariaLabel={altText}
						/>
					)}
					{tag && (
						<div class={joinClasses(s.tileTag, useTileSlantyTag && s.tileTagSlant, 'smallB')}>
							<span>{tag}</span>
						</div>
					)}
				</div>
				<div class={joinClasses(s.details, path && s.clickable)}>
					<h4 class="h4">{title}</h4>
					<HTML tag="span" markdown class={joinClasses(s.teaser, 'small')}>{teaser}</HTML>
					<Buttons
						ref={ref => this.buttons = ref}
						data={buttons}
						filmTitle={title}
						carouselTitle={carouselTitle}
						carouselHeader={carouselHeader}
						tileId={id}
						carouselId={this.props.carouselId}
						buttonType="tile"
					/>
				</div>
				{textOverlayContent && this.renderTextOverlay(textOverlayContent)}
			</div>
		);
	}

}
